<p class="qundis-page-heading-h1">Bitte vergeben Sie ein neues Passwort</p>
<form class="admin-form user-form" [formGroup]="passwordUpdateForm">
  <mat-form-field>
    <mat-label>Neues Passwort</mat-label>
    <div class="d-flex">
      <input
        [type]="hide() ? 'password' : 'text'"
        matInput
        placeholder="Neues Passwort"
        formControlName="password"
        required
      />
      <i
        [class]="hide() ? 'bi bi-eye-slash' : 'bi bi-eye'"
        class="cursor-pointer"
        (click)="hide.set(!hide())"
      ></i>
    </div>
  </mat-form-field>
  <mat-form-field class="full-width">
    <mat-label>Neues Passwort bestätigen</mat-label>
    <div class="d-flex">
      <input
        [type]="hide() ? 'password' : 'text'"
        matInput
        placeholder="Neues Passwort betätigen"
        formControlName="passwordConfirm"
        required
      />
      <i [class]="hide() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
    </div>

    <mat-error *ngIf="passwordConfirmControl.invalid"
      >Die Passwörter stimmen nicht überein</mat-error
    >
  </mat-form-field>
</form>
<div style="color: #ff7355" *ngIf="passwordUpdateForm.get(['passwords'])"></div>
<button
  (click)="updatePassword()"
  [disabled]="!passwordUpdateForm.valid"
  class="btn btn-qundis-primary mt-3"
>
  Bestätigen
</button>
